var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-item-setting" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "setting-tabs",
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基础设置", name: "first" } },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "top", onsubmit: "return false" }
                },
                _vm._l(_vm.baseOptionAttrs, function(componentName, i) {
                  return _c(componentName, {
                    key: i,
                    tag: "component",
                    model: {
                      value: _vm.componentConfig,
                      callback: function($$v) {
                        _vm.componentConfig = $$v
                      },
                      expression: "componentConfig"
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "样式设置", name: "second" } },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "top", onsubmit: "return false" }
                },
                [
                  _vm.styleOptionAttrs.length != 0
                    ? _c(
                        "div",
                        { staticClass: "setting-style" },
                        [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("组件样式")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.styleOptionAttrs, function(
                            componentName,
                            i
                          ) {
                            return _c(componentName, {
                              key: i,
                              tag: "component",
                              model: {
                                value: _vm.componentConfig,
                                callback: function($$v) {
                                  _vm.componentConfig = $$v
                                },
                                expression: "componentConfig"
                              }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.renderOptionAttrs.length != 0
                    ? _c(
                        "div",
                        { staticClass: "setting-style" },
                        [
                          _c("p", { staticClass: "title" }, [
                            _vm._v("模板样式")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.renderOptionAttrs, function(
                            componentName,
                            i
                          ) {
                            return _c(componentName, {
                              key: i,
                              tag: "component",
                              model: {
                                value: _vm.componentConfig,
                                callback: function($$v) {
                                  _vm.componentConfig = $$v
                                },
                                expression: "componentConfig"
                              }
                            })
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "表单设置", name: "third" } },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "top", onsubmit: "return false" }
                },
                [
                  _vm.formList.length != 0
                    ? _c(
                        "div",
                        { staticClass: "setting-style" },
                        _vm._l(_vm.formConfig, function(componentName, i) {
                          return _c(componentName, { key: i, tag: "component" })
                        }),
                        1
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e821610c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e821610c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/FormItemSetting.vue
// module id = null
// module chunks = 